export default "__VITE_ASSET__BEG11HWR__"